import { UserRole } from '../types';
import api from '../api';

export function assign(userId: string, roleId: string): Promise<UserRole> {
  return api
    .post(`users/${userId}/roles`, { roleId })
    .then(response => response.data);
}

export function unassign(userRoleId: string): Promise<void> {
  return api
    .delete(`user-roles/${userRoleId}`)
    .then(() => undefined);
}
